import { render, staticRenderFns } from "./DefaultWrapper.vue?vue&type=template&id=66827612"
import script from "./DefaultWrapper.vue?vue&type=script&lang=js"
export * from "./DefaultWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports